import React, { useEffect } from 'react';
import { AlertBar } from './components/AlertBar';
import { Hero } from './components/Hero';
import { ForWho } from './components/ForWho';
import { Problem } from './components/Problem';
import { Transformation } from './components/Transformation';
import { Benefits } from './components/Benefits';
import { ProductBreakdown } from './components/ProductBreakdown';
import { ProductPreview } from './components/ProductPreview';
import { ValueStack } from './components/ValueStack';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initializeMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="28s30zixi6bym">
      <AlertBar data-id="element-1" data-mp="23ujl6el5pr4k" />
      <main data-id="element-2" data-mp="23v2tr4ox335x">
        <Hero data-id="element-3" data-mp="23ti8k5ohswkq" />
        <ForWho data-id="element-4" data-mp="3ijxsgzk2wgo4" />
        <Problem data-id="element-5" data-mp="3ikh9me1wn113" />
        <Transformation data-id="element-6" data-mp="3iiwg8rrbto4t" />
        <Benefits data-id="element-7" data-mp="3ijpd910hgz9r" />
        <ProductBreakdown data-id="element-8" data-mp="3ii4r9zs8ioni" />
        <ProductPreview data-id="element-9" data-mp="3ml1397n9rmih" />
        <ValueStack data-id="element-10" data-mp="3mk8710lxsfel" />
        <Offer data-id="element-11" data-mp="3mjq2zht18ww4" />
        <Testimonials data-id="element-12" data-mp="3mj6hjr46bqdc" />
        <FAQ data-id="element-13" data-mp="3rcj846sey78q" />
        <FinalCTA data-id="element-14" data-mp="3rbzlwdvqcwow" />
      </main>
      <Footer data-id="element-15" data-mp="3rcswxr1q28cu" />
    </div>;
}